export const DIMENSION = 240;
